var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z",
    fill: "#1D4F8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01953 14.7704C8.01953 15.1846 8.35532 15.5204 8.76953 15.5204H8.9379H15.0603H15.2287C15.6429 15.5204 15.9787 15.1846 15.9787 14.7704V6.94898H8.01953V14.7704ZM9.74915 12.1531C9.33493 12.1531 8.99915 11.8173 8.99915 11.4031V8.625C8.99915 8.21079 9.33493 7.875 9.74915 7.875H14.2491C14.6634 7.875 14.9991 8.21079 14.9991 8.625V11.4031C14.9991 11.8173 14.6634 12.1531 14.2491 12.1531H9.74915Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63178 6.33673C8.29364 6.33673 8.01953 6.06262 8.01953 5.72449V6.33673H8.63178Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3665 4.5H8.63178C8.29364 4.5 8.01953 4.77411 8.01953 5.11224V5.72449C8.01953 6.06262 8.29364 6.33673 8.63178 6.33673H15.3665C15.7046 6.33673 15.9787 6.06262 15.9787 5.72449V5.11224C15.9787 4.77411 15.7046 4.5 15.3665 4.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9787 5.72449C15.9787 6.06262 15.7046 6.33673 15.3665 6.33673H15.9787V5.72449Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55014 19.5H14.4481C14.7862 19.5 14.9991 19.2259 14.9991 18.8878V16.1327H8.99915V18.8878C8.99915 19.2259 9.21201 19.5 9.55014 19.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingMachine);
export default __webpack_public_path__ + "static/media/parking-machine.d9a601664f98ec428304c8de2b6cd780.svg";
export { ForwardRef as ReactComponent };